import { forwardRef } from 'react'

import { Polymorphic } from '../../../utils/PolymorphicUtils'

export type TypographyProps = {
  scale:
    | 'h1'
    | 'h2'
    | 'h3'
    | 'h4'
    | 'subtitle-small'
    | 'body-large'
    | 'body'
    | 'body-small'
    | 'overline'
    | 'caption'
  emphasis: 'default' | 'strong' | 'muted'
}

const scaleClasses: Record<TypographyProps['scale'], string> = {
  h1: 'text-4xl md:text-6xl font-semibold leading-tight',
  h2: 'text-3xl md:text-4xl font-semibold leading-tight',
  h3: 'text-2xl md:text-3xl font-semibold leading-tight',
  h4: 'text-xl md:text-2xl font-semibold leading-tight',
  'subtitle-small': 'text-sm font-semibold',
  'body-large': 'text-lg',
  body: 'text-base',
  'body-small': 'text-sm',
  overline: 'text-xs tracking-[0.3em] font-mono uppercase',
  caption: '',
}

const emphasisClasses: Record<TypographyProps['emphasis'], string> = {
  default: 'text-ink-600 dark:text-ink-200',
  strong: 'text-ink-900 dark:text-ink-50',
  muted: 'text-ink-400 dark:text-ink-300',
}

export const Typography = forwardRef(function Typography(
  { as: Component = 'p', scale, emphasis, className, ...props },
  ref,
) {
  const classNames = [scaleClasses[scale], emphasisClasses[emphasis], className]
    .filter(Boolean)
    .join(' ')

  return <Component className={classNames} {...props} ref={ref} />
}) as Polymorphic<'p', TypographyProps>
